import { call, put } from 'redux-saga/effects';

import api, { makeOptions } from '../../services/api';
import LdEquipamentosSmcListActions from '../ducks/ld-equipamentos-smc';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* fetchSelect() {
  try {
    // const authData = yield select(getAuthData);
    const url = `ld-equipamentos-smc?paginate=false`;
    const { data: responseData } = yield call(
      api.get,
      url,
      makeOptions(dataLocal.auth.data),
    );
    const { data } = responseData;
    const list = data.map(({ uuid, name }) => ({
      value: uuid,
      label: name,
    }));
    yield put(LdEquipamentosSmcListActions.showSuccess(list));
  } catch (err) {
    yield put(
      LdEquipamentosSmcListActions.showFailure(err.response.data.error.message),
    );
  }
}
